export class ShowToastErrorAction {
  static readonly type = '[AppError] ShowToastErrorAction';

  constructor(public message: string, public icon?: string, public duration?: number) {
  }
}
